import SidebarComponent from "../../components/Sidebar/SidebarComponent";
import { useEffect, useState } from "react";
import { getAllTransferByUserService } from "./services/transfer.service";
import { WithdrawalRequest } from "./models/transfer.model";
import TableTransfer from "./components/TableTransfer";
import { dataTableTransferAdapter } from "./adapters/transfer.adapter";

const viewStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  .transfer-root-container {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background-color: #f8fafc;
    min-height: 100vh;
    display: flex;
  }

  .transfer-main-content {
    flex-grow: 1;
    padding: 2rem 2.5rem;
    transition: all 0.3s ease;
    max-width: 1400px;
    margin: 0 auto;
    width: 100%;
  }

  .transfer-glass-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 20px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.02), 0 8px 10px -6px rgba(0, 0, 0, 0.02);
    padding: 2rem;
    animation: fadeInUp 0.4s ease-out;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .title-icon-box {
    background-color: #e6faf2;
    color: #00A86B;
    border-radius: 12px;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    .transfer-main-content {
      padding: 1.25rem;
    }
    .transfer-glass-card {
      padding: 1.25rem;
      border-radius: 16px;
    }
  }
`;

function Transfer(): JSX.Element {
  const idUser = localStorage.getItem("idUser");
  const [tableTransaction, setTableTransaction] = useState<WithdrawalRequest[]>([]);

  const getAllTransferByUser = async (): Promise<void> => {
    try {
      if (idUser) {
        const getAllTransfer = await getAllTransferByUserService(+idUser);
        if (getAllTransfer.length > 0 && getAllTransfer[0] !== null) {
          setTableTransaction(dataTableTransferAdapter(getAllTransfer));
        }
      } else {
        window.location.href = "/";
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllTransferByUser();
  }, [idUser]);

  return (
    <div className="transfer-root-container">
      <style>{viewStyles}</style>
      
      <SidebarComponent />
      
      <main className="transfer-main-content">
        <div className="transfer-glass-card">
          
          {/* Header de la Vista */}
          <div className="flex align-items-center justify-content-between pb-4 border-bottom-1 surface-border mb-4">
            <div className="flex align-items-center gap-3">
              <div className="title-icon-box shadow-1">
                <i className="pi pi-history text-xl"></i>
              </div>
              <div className="flex flex-column">
                <h1 
                  className="text-xl md:text-2xl font-bold m-0 tracking-tight"
                  style={{ color: '#1e293b' }} 
                >
                  Historial de Transacciones
                </h1>
                <p className="text-sm text-500 m-0 mt-1 hidden sm:block">
                  Panel de movimientos realizados en tu cuenta. Revisa estados y fechas de registro.
                </p>
              </div>
            </div>
            
            <div className="hidden md:flex align-items-center gap-2 bg-gray-100 px-3 py-1.5 border-round-2xl text-xs font-semibold text-600 border-1 surface-border">
              <span className="border-circle" style={{ backgroundColor: '#00A86B', display: 'inline-block', width: '8px', height: '8px' }}></span>
              Sincronizado
            </div>
          </div>
          
          {/* Sección de la Tabla */}
          <div className="w-full overflow-x-auto">
            <TableTransfer tableTransaction={tableTransaction} />
          </div>

        </div>
      </main>
    </div>
  );
}

export default Transfer;